import React, {useEffect} from 'react';
import Breadcrumbs from "../../../../ui/Breadcrumbs";
import Box from "../../../../ui/Box";
import { withStyles } from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import InventoryTypeList from "./InventoryTypeList";
import RoomTypeList from "./RoomTypeList";

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Материально-технические ресурсы",
    link: "/work/app/manage/resources/mattech"
  },
  {
    label: "Номенклатура",
    link: "#"
  },
];

const styles = {
  root: {
    display: "block",
    width: "100%",
    height: "calc(100vh - 150px)"
  }
};

class Nomenclature extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      classes
    } = this.props;
    const { root } = classes;

    return (
      <div>
        <Breadcrumbs items={items} />
        <div className={root}>
          <Box>
            <Grid container spacing={0} justify="flex-start" alignItems="flex-start">
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <RoomTypeList/>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <InventoryTypeList/>
              </Grid>
            </Grid>
          </Box>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Nomenclature);
